// OpportunityStage.js
import React, { useEffect, useState } from "react";
import { Menu, MenuItem } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  setOppertunity,
  setOppertunityStage,
} from "../../../../redux/slices/MsgSlice";
import { oppertunityInbox } from "../../../../components/Header/Data3";
import { Button } from "reactstrap";
import { FaChevronDown } from "react-icons/fa";

const OpportunityStage = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [currentMenu, setCurrentMenu] = useState(false);
  const { oppertunity, oppertunityStage, selectedConvo } = useSelector(
    (state) => state.messages
  );
  const islogin = useSelector((state) => state.user.isLogin);
  const userinfo = useSelector((state) => state.user.userInfo);
  const user = islogin ? JSON.parse(userinfo) : null;
  // const [oppertunityStage, setOppertunityStage] = useState(false);
  const dispatch = useDispatch();
  const isAdmin = user && user.Role === "admin"; // Check if user is admin

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setCurrentMenu(true);
  };

  // const [oppertunity, setOppertunity] = useState("");
  console.log(oppertunity, "oppertunity--111");
  const addOppertunityStage = async () => {
    if (oppertunity && selectedConvo) {
      const formData = {
        messageId: selectedConvo?.Id,
        Type: oppertunity.value || oppertunity || 0,
        createdBy:
          selectedConvo?.createdBy !== user?.UserID
            ? selectedConvo?.customerId
            : selectedConvo?.createdBy,
        receivedBy:
          selectedConvo?.createdBy === user?.UserID
            ? selectedConvo?.customerId
            : selectedConvo?.createdBy,
      };
      console.log(formData, "oppertunity");
      await oppertunityInbox(formData);
      dispatch(setOppertunityStage(false));
    }
  };
  useEffect(() => {
    if (oppertunityStage) {
      addOppertunityStage();
    }
  }, [oppertunityStage]);
  const handleChange = (option) => {
    dispatch(setOppertunity(option));
    dispatch(setOppertunityStage(true));
  };
  const handleClose = () => {
    setAnchorEl(null);
    setCurrentMenu(false);
  };
  const options = [
    { value: 0, label: "Opportunity Stage" },
    { value: 1, label: "Hot Lead ❤️‍🔥" },
    { value: 2, label: "Cold Lead 🥶" },
    { value: 3, label: "Invoice Sent" },
    { value: 4, label: "Booked" },
    { value: 5, label: "Event Completed" },
    { value: 6, label: "Meeting Scheduled" },
    { value: 7, label: "Not Interested" },
    { value: 8, label: "Booked Elsewhere" },
    { value: 9, label: "Cancelled" },
  ];
  return (
    <div className="wc-chat-drop">
      <Button
        className="drop-button"
        style={{
          backgroundColor: "#c4c4c4ff",
          color: "black",
          fontSize: "small",
        }}
        size="sm"
        onClick={handleClick}
        disabled={!(isAdmin || selectedConvo.createdBy === user.UserID)}
      >
        <span className="drop-button-title px-2">
          {oppertunity.label || "Opportunity Stage"}
          <FaChevronDown size={10} />
        </span>
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={currentMenu}
        onClose={handleClose}
        PaperProps={{
          style: {
            minWidth: "120px",
            maxWidth: "200px",
          },
        }}
        disableScrollLock={true}
      >
        {options.map((option) => (
          <MenuItem
            key={option.value}
            value={option.value}
            onClick={() => {
              handleChange(option);
              handleClose();
            }}
          >
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default OpportunityStage;
